/**
 * The one scheme in `authorities`, or null when there is none or more than one. An offer delivers to
 * one registry, so the counterparty's account must fit exactly this scheme.
 */
export function singleAuthority<T>(authorities: ReadonlySet<T>): T | null {
  return authorities.size === 1 ? ([...authorities][0] ?? null) : null;
}

/**
 * The i18n key of the first reason an offer cannot be sent yet, or null; the order is what the buyer
 * is told first. The backend refuses each of these too.
 *
 * @property noSelectionKey - The page's own wording for "nothing picked yet"
 * @property termsBlockingKey - `useOfferTerms().blockingKey`
 * @property authorities - The certificate schemes of what is picked
 */
export function offerBlockingKey(gate: {
  hasSelection: boolean;
  noSelectionKey: string;
  termsBlockingKey: string | null;
  authorities: ReadonlySet<unknown>;
}): string | null {
  if (!gate.hasSelection) return gate.noSelectionKey;
  if (gate.termsBlockingKey) return gate.termsBlockingKey;
  if (gate.authorities.size > 1)
    return "soldera_inventory.blocked.mixed_authorities";
  return null;
}
